import { RECORDS_INITIAL_COUNT } from '../constants'

export const getRecords = ({ viewAllRecords, records = []}) =>
  viewAllRecords ? records : records.slice(0, RECORDS_INITIAL_COUNT)

export const getProductUniqueId = ({
  product: {
    attributes: {
      frontTire: [{ frontTireSkuId } = {}] = [],
      rearTire: [{ rearTireSkuId } = {}] = []
    } = {}
  } = {},
  index
}) =>
  rearTireSkuId ?
    `${rearTireSkuId}-${frontTireSkuId}-${index}` : `${frontTireSkuId}-${index}`

export const getGBBFilteredRecords = (records, gBBDetails) => records.filter(({
  attributes: {
    frontTire: [{ frontTireSkuId } = {}] = []
  } = {}
} = {}) => !(gBBDetails[frontTireSkuId]))
